import config from "../config";
import { TransactionAudit } from "./apiDP";

// const BASE_URL = "https://scope3-beqcpanel.testgrowindigo.co.in/";
const BASE_URL = config.QC_API_URL+"/";

// Helper function for API calls
const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "API request failed");
  }
  return response.json();
};

// User related APIs
export const fetchUsers = async (emailId) => {
  try {
    const response = await fetch(`${BASE_URL}api/user/getDetails/${emailId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching user data:", error);
    return null;
  }
};

export const fetchMembers = async (emailId) => {
  try {
    const response = await fetch(
      `${BASE_URL}api/user/getMembersDropDown?emailId=${emailId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching user data:", error);
    return null;
  }
};

// Transaction related APIs
export const fetchAdminTransactions = async (emailId) => {
  try {
    const response = await fetch(
      `${BASE_URL}api/transaction_audit/getAdminTransactions?emailId=${encodeURIComponent(
        emailId
      )}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "Failed to fetch data");

    return data;
  } catch (error) {
    console.error("Error fetching transactions:", error.message);
    return null;
  }
};

export const fetchMemberTransactions = async (emailId) => {
  try {
    const response = await fetch(
      `${BASE_URL}api/transaction_audit/getMemberTransactions?emailId=${emailId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching user data:", error);
    return null;
  }
};

export const fetchTransaction = async (transaction_id) => {
  try {
    const response = await fetch(
      `${BASE_URL}api/transaction_audit/getCompleteTransaction?transactionId=${encodeURIComponent(
        transaction_id
      )}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );

    const data = await response.json();
    if (!response.ok)
      throw new Error(data.error || "Failed to fetch transaction");

    return data;
  } catch (error) {
    console.error("Error fetching transaction details:", error.message);
    return null;
  }
};

export const updateTransaction = async (
  transactionId,
  memberEmailId,
  additionalData = {}
) => {
  try {
    const response = await fetch(
      `${BASE_URL}api/transaction_audit/updateTransaction`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          transaction_id: transactionId,
          member_email_id: memberEmailId,
          ...additionalData, // Allows for sending extra fields if needed
        }),
      }
    );

    const data = await response.text(); // Expecting a plain string response
    if (!response.ok) throw new Error(data || "Failed to update transaction");

    return data;
  } catch (error) {
    console.error("Error updating transaction:", error.message);
    return null;
  }
};

export const rejectTransaction = async (transactionId, adminEmailId) => {
  console.log(adminEmailId);
  try {
    const response = await fetch(
      `${BASE_URL}api/transaction_audit/revertTransaction`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          transaction_id: transactionId,
          admin_email_id: adminEmailId,
        }),
      }
    );

    const data = await response.text(); // Expecting a plain string response
    if (!response.ok) throw new Error(data || "Failed to revert transaction");

    return data;
  } catch (error) {
    console.error("Error reverting transaction:", error.message);
    return null;
  }
};

export const acceptTransaction = async (transactionId, adminEmailId) => {
  try {
    const response = await fetch(
      `${BASE_URL}api/transaction_audit/sendToBlockchain`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          transaction_id: transactionId,
          admin_email_id: adminEmailId,
        }),
      }
    );

    const data = await response.text(); // Expecting a plain string response
    if (!response.ok) throw new Error(data || "Failed to accept transaction");

    return data;
  } catch (error) {
    console.error("Error accepting transaction:", error.message);
    return null;
  }
};

export const assignMemberEmail = async (
  transactionId,
  adminEmailId,
  memberEmailId
) => {
  try {
    const response = await fetch(
      `${BASE_URL}api/transaction_audit/assignMemberEmail`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          transaction_id: transactionId,
          admin_email_id: adminEmailId,
          member_email_id: memberEmailId,
        }),
      }
    );

    const data = await response.text(); // Expecting a plain string response
    if (!response.ok) throw new Error(data || "Failed to assign member email");

    return data;
  } catch (error) {
    console.error("Error assigning member email:", error.message);
    return null;
  }
};

export const fetchRejected = async (emailId) => {
  try {
    const response = await fetch(
      `${BASE_URL}api/transaction_audit/getRejectedTransactions?emailId=${encodeURIComponent(
        emailId
      )}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "Failed to fetch data");

    return data;
  } catch (error) {
    console.error("Error fetching transactions:", error.message);
    return null;
  }
};
